import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Brands", href: "#brands" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Vision", href: "#vision" },
  { label: "Contact", href: "#contact" },
];

const TESTIMONIALS_URL = "https://instagram.com/feedbacks";

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const smoothTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <>
      <header
        data-testid="nav-header"
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
          scrolled ? "bg-bg/70 backdrop-blur-sm" : "bg-transparent"
        }`}
      >
        <div className="flex items-center justify-between px-6 md:px-10 lg:px-14 py-5">
          <a
            href="#top"
            onClick={(e) => smoothTo(e, "#top")}
            data-testid="nav-logo"
            className="font-serif text-2xl md:text-3xl tracking-tight"
          >
            Akanksha<span className="italic text-mute"> Chandok</span>
          </a>
          <nav className="hidden md:flex items-center gap-8 lg:gap-10">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => smoothTo(e, l.href)}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="edit-link label"
              >
                {l.label}
              </a>
            ))}
            <a
              href={TESTIMONIALS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-link-testimonials"
              className="group inline-flex items-center gap-1.5 label text-ink border-b border-ink/50 hover:border-ink pb-0.5 transition-colors"
            >
              Our Testimonials
              <ArrowUpRight
                className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300"
                strokeWidth={1.5}
              />
            </a>
          </nav>
          <button
            onClick={() => setOpen((o) => !o)}
            className="md:hidden label"
            data-testid="nav-menu-toggle"
          >
            {open ? "Close" : "Menu"}
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-panel"
            initial={{ y: "-100%" }}
            animate={{ y: 0 }}
            exit={{ y: "-100%" }}
            transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
            className="fixed inset-0 z-40 bg-bg md:hidden flex flex-col items-start justify-center px-8 gap-6"
          >
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => smoothTo(e, l.href)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="font-serif text-5xl italic"
              >
                {l.label}
              </a>
            ))}
            <a
              href={TESTIMONIALS_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-link-testimonials"
              className="font-serif text-3xl italic inline-flex items-center gap-2 mt-2"
            >
              Our Testimonials
              <ArrowUpRight className="w-6 h-6" strokeWidth={1.2} />
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Nav;
